"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _styles = require("@material-ui/core/styles");
// Modeled after https://mui.com/system/the-sx-prop/#main-content
// We want to allow developers to customize the margin and padding, but no other styles.
// V5 of Material UI won't need this; they provide the ability to custom inject styles as a prop.

// By default, spacing is 8px in theme.
var theme = (0, _styles.createTheme)();

// We will support all shorthands listed at https://mui.com/system/the-sx-prop/ with v5.
var spacingAllowList = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'];
var toKebabCase = function toKebabCase(str) {
  return str.split('').map(function (letter, idx) {
    return letter.toUpperCase() === letter ? "".concat(idx !== 0 ? '-' : '').concat(letter.toLowerCase()) : letter;
  }).join('');
};
var filterValidProps = function filterValidProps(sxProps) {
  if (!sxProps) {
    return {};
  }
  return Object.fromEntries(Object.entries(sxProps).filter(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      key = _ref2[0],
      _ = _ref2[1];
    return spacingAllowList.includes(key);
  }));
};
var createMuiSpacingRules = function createMuiSpacingRules(sxProps) {
  return Object.entries(filterValidProps(sxProps)).reduce(function (prev, _ref3) {
    var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return prev + "".concat(toKebabCase(key), ": ").concat(theme.spacing(value), "px !important;\n");
  }, '');
};
var _default = exports["default"] = createMuiSpacingRules;